const initialState = {
    title: '',
    reason: '',
    abuseWord: '',
    collaboratorBlockedAppeal: false
}

export const APPEAL_ACTION_TYPE = {
    SET_TITLE: 'SET_TITLE',
    SET_REASON: 'SET_REASON',
    SET_ABUSE_WORD: 'SET_ABUSE_WORD',
    SET_COLLABORATOR_BLOCKED_APPEAL: 'SET_COLLABORATOR_BLOCKED_APPEAL'
}

const adminAppealReducer = (state = initialState, action) => {
    switch (action.type) {
        case (APPEAL_ACTION_TYPE.SET_TITLE):
            return {
                ...state,
                title: action.payload
            }
        case (APPEAL_ACTION_TYPE.SET_ABUSE_WORD):
            return {
                ...state,
                abuseWord: action.payload
            }
        case (APPEAL_ACTION_TYPE.SET_COLLABORATOR_BLOCKED_APPEAL):
            return {
                ...state,
                collaboratorBlockedAppeal: action.payload
            }
        case (APPEAL_ACTION_TYPE.SET_REASON):
            return {
                ...state,
                reason: action.payload
            }
        default:
            return state
    }
}

export default adminAppealReducer